import { render, staticRenderFns } from "./Footer-en.vue?vue&type=template&id=21ffaed4&scoped=true"
import script from "./Footer-en.vue?vue&type=script&lang=js"
export * from "./Footer-en.vue?vue&type=script&lang=js"
import style0 from "./Footer-en.vue?vue&type=style&index=0&id=21ffaed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffaed4",
  null
  
)

export default component.exports